import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { CommunityMember } from '../../services/communityService';

interface Props {
  open: boolean;
  member: CommunityMember | null;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmRemoveMemberDialog: React.FC<Props> = ({
  open,
  member,
  loading,
  onConfirm,
  onCancel,
}) => {
  const name = member?.display_name || member?.client_id || 'this member';

  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Remove from community?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ color: '#5f6368' }}>
          {name} will be removed from this community. They can rejoin with a new invite link.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};
